module.exports = __webpack_public_path__ + "static/Raleway-Regular-75b4247fdd3b97d0e3b8e07b115673c2.ttf";